import { render, staticRenderFns } from "./ruanjian_zonghe_mx.vue?vue&type=template&id=e8b3f37c&scoped=true"
import script from "./ruanjian_zonghe_mx.vue?vue&type=script&lang=js"
export * from "./ruanjian_zonghe_mx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3f37c",
  null
  
)

export default component.exports